export class Maintenance {
  constructor(
    public announcementOn: boolean,
    public announcementText: string,
    public maintenanceOn: boolean,
    public maintenanceText: string
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/maintenance.model.ts